import React from 'react';
import styles from './MountainCardSkeleton.module.css';

function MountainCardSkeleton() {
  return (
    <div className={styles.skeletonCard}>
      <div className={styles.imageWrap}>
        <div className={styles.shimmer}></div>
        <div className={styles.overlay}>
          <div className={styles.textLine}></div>
          <div className={styles.titleLine}></div>
        </div>
      </div>
    </div>
  );
}

export default MountainCardSkeleton;
